
{
  "familyId": "SPR-LEEN-LATIJN",
  "questions": [
    {
      "id": "SPR-LEEN-LATIJN-001",
      "familyId": "SPR-LEEN-LATIJN",
      "module": "SpellingRegel",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_latijn_mv",
      "questionType": "multiple_choice",
      "question": "Wat is het meervoud van 'museum'?",
      "context": null,
      "options": ["musea", "museums", "museumen", "museum's"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Latijnse meervouden", "content": "Latijnse woorden op -um krijgen in het meervoud -a: museum → musea, aquarium → aquaria. Dit moet je uit je hoofd leren.", "icon": "book" }, "showWhen": "wrong" }],
      "conceptId": "latin_plural_um_a",
      "variantIndex": 1,
      "feedback": { "explanationText": "Dit is een Latijns leenwoord. Woorden op -um krijgen in het meervoud -a: museum → musea. Andere voorbeelden: aquarium → aquaria, podium → podia.", "distractorExplanations": { "0": "Correct! Latijns meervoud: -um wordt -a: musea.", "1": "Fout: dit is het Engelse meervoud. In het Nederlands is het musea (Latijns).", "2": "Fout: je voegt geen -en toe. Het Latijnse meervoud is musea.", "3": "Fout: je gebruikt geen apostrof. Het Latijnse meervoud is musea." } }
    },
    {
      "id": "SPR-LEEN-LATIJN-002",
      "familyId": "SPR-LEEN-LATIJN",
      "module": "SpellingRegel",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_latijn_mv",
      "questionType": "multiple_choice",
      "question": "Welke zin is juist?",
      "context": null,
      "options": ["In de stad zijn drie centra.", "In de stad zijn drie centrums.", "In de stad zijn drie centren.", "In de stad zijn drie centrum."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Centrum → centra", "content": "Centrum is Latijns en krijgt het meervoud centra (niet centrums). Woorden op -um worden -a: centrum → centra, museum → musea.", "icon": "book" }, "showWhen": "wrong" }],
      "conceptId": "latin_plural_centrum",
      "variantIndex": 2,
      "feedback": { "explanationText": "Centrum is een Latijns woord. Het meervoud is centra (niet centrums). Woorden op -um worden -a in het meervoud.", "distractorExplanations": { "0": "Correct! Latijns meervoud: centrum → centra.", "1": "Fout: dit is het Engelse meervoud. In het Nederlands is het centra (Latijns).", "2": "Fout: je voegt geen -en toe. Het Latijnse meervoud is centra.", "3": "Fout: 'drie centrum' is enkelvoud. Het meervoud is centra." } }
    }
  ]
}
